
function makeUserValidator(type, $q, $http, ApiUrl) {
    var url = ApiUrl('person', 'unique'),
        typeUC = type[0].toUpperCase() + type.substr(1),
        name = 'userUnique' + typeUC;

    return {
        require: '?ngModel',
        scope: {user: '=' + name},
        link: function(scope, element, attrs, ngModel) {
            if (!ngModel) return;

            function checkUnique(value) {
                var params;

                // Empty is alwasy valid, use ng-required
                if (!value) return $q.when(true);

                params = {
                    type: type,
                    value: value,
                    user_id: scope.user && scope.user.id,
                };

                return $http.get(url, {params: params}).then(function(response) {
                    if (response.data.unique) return true;
                    return $q.reject();
                });
            }

            ngModel.$asyncValidators[name] = checkUnique;
        },
    }
}


module.directive('userUniqueEmail', function($q, $http, ApiUrl) {
    return makeUserValidator('email', $q, $http, ApiUrl);
});

module.directive('userUniqueUsername', function($q, $http, ApiUrl) {
    return makeUserValidator('username', $q, $http, ApiUrl);
});
